<template>
  <div class="page-my-order">
    <div class="time-box">
      <div class="time-range-pick-container">
        <div @click="openPickDate(0)">{{ form.startDate | formatDate }}</div>
        <div class="line"></div>
        <div @click="openPickDate(1)">{{ form.endDate | formatDate }}</div>
      </div>
    </div>
    <pi-tabs :list="tabsList" :active="active" @change="tabsClick"></pi-tabs>

    <template v-for="(item, index) in tabsList">
      <my-order-tab
        :formData="form"
        :key="index"
        :value="item.value"
        :active="active"
        :orderStatus="item.orderStatus"
        v-if="item.isLoading"
        v-show="item.value == active"
      ></my-order-tab>
    </template>

    <!--日期选择框-->
    <van-popup v-model="showTimePicker" position="bottom">
      <van-datetime-picker
        v-model="dateTimePickDate"
        :title="pickerTitle"
        type="date"
        :style="{ height: '50%' }"
        :min-date="minDate"
        v-on:confirm="onTimePickClick(true)"
        v-on:cancel="onTimePickClick"
      />
    </van-popup>
  </div>
</template>
<script>
import { Tab, Tabs, List, Icon, Popup, DatetimePicker } from "vant";
import { upOrderRead, getUserAccount, getUserVipType } from "../../common/api";
import piTabs from "@/components/pi-tabs/pi-tabs";
import myOrderTab from "./components/my-order-tab.vue";

export default {
  name: "my-order",
  components: {
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [List.name]: List,
    [Icon.name]: Icon,
    [Popup.name]: Popup,
    [DatetimePicker.name]: DatetimePicker,
    [piTabs.name]: piTabs,
    [myOrderTab.name]: myOrderTab,
  },
  data() {
    return {
      form: {
        startDate: "",
        endDate: "",
      },
      active: "0",

      showTimePicker: false,
      minDate: new Date(2020, 0),
      dateTimePickDate: null,
      chooseDateType: 0, // 0开始， 1结束
      pickerTitle: "",
      tabsList: [
        { name: "全部", value: "0", orderStatus: null, isLoading: false },
        { name: "充电中", value: "1", orderStatus: "1", isLoading: false },
        { name: "已支付", value: "2", orderStatus: "6", isLoading: false },
        { name: "异常", value: "3", orderStatus: "4", isLoading: false },
      ],

      isEntPayOrder: null,
      isGoBack: false,
    };
  },
  beforeRouteLeave(to, from, next) {
    let data = {
      active: this.active,
      startDate: this.form.startDate,
      endDate: this.form.endDate,
    };
    if (to.path == "/my/order/details") {
      this.$common.save("order-list-form", data);
    }

    next();
  },
  created() {
    let orderNo = this.$route.query.orderNo;
    if (orderNo) {
      let orderNos = typeof orderNo === "string" ? orderNo.split(",") : orderNo;
      this.upOrderRead(orderNos);
    }

    this.initData();
  },
  methods: {
    upOrderRead(orderNos) {
      upOrderRead({
        orderNos: orderNos,
      }).then(() => {});
    },
    async initData() {
      let query = this.$route.query;
      let title = "我的订单";
      // 订单状态
      if (query.orderStatus != undefined) {
        this.form.orderStatus =
          query.orderStatus == "5" || query.orderStatus == "0"
            ? 0
            : query.orderStatus;
      }

      // 企业管理员
      if (query.type == "entAdminOrder") {
        this.$set(this.form,'entUserPkId',query.entUserPkId)
        this.$set(this.form,'isEntPayOrder',query.isEntPayOrder || false)
        title =
          query.isEntPayOrder == true || query.isEntPayOrder == "true"
            ? "统付订单"
            : "个付订单";
      } else {
        // 点击“企业支付”或者“企业个人支付”的订单过来，要请求一下 vip 类型
        if (query.type == "entOrder" || query.type == "entUserOrder") {
          if (query.accountPkId) {
            title = "统付订单";
            this.form.accountPkId = query.accountPkId;
          } else {
            title = "个付订单";
          }
          this.form.vipType = await this.getUserVipType();
        }
        // 个人支付 或者企业个人支付 要先请求一下账户ID，没带过来
        if (!this.form.accountPkId) {
          const data = await this.getUserAccount();
          this.form.accountPkId = data.accountPkId;
        }
      }
      document.title = title;
      this.initFormData();
    },
    initFormData() {
      let endDate = new Date();
      let startDate = "";
      let orderForm = this.$common.get("order-list-form");
      if (orderForm) {
        this.$common.remove("order-list-form");
        startDate = new Date(orderForm.startDate);
        endDate = new Date(orderForm.endDate);
        this.active = orderForm.active;
        if (!this.tabsList[this.active].isLoading) {
          this.tabsList[this.active].isLoading = true;
        }
      } else {
        this.tabsList[this.active].isLoading = true;
        let d = new Date();
        var tYear = d.getFullYear() - 1;
        var m = d.getMonth();
        var dd = d.getDate();

        startDate = new Date(tYear, m, dd);
      }
      this.form.startDate = startDate;
      this.form.endDate = endDate;
    },
    /**
     * 获取账户信息
     * @returns
     */
    getUserAccount() {
      return new Promise(async (resolve) => {
        const ret = await getUserAccount({});
        let data = ret.data[0] || "";
        resolve(data);
      });
    },
    /**
     * 获取用户的 vip 等级
     * @returns
     */
    async getUserVipType() {
      return new Promise(async (resolve) => {
        const ret = await getUserVipType({});
        let data = ret.data[0] || "";
        resolve(data);
      });
    },
    tabsClick(data) {
      if (!this.tabsList[data.value].isLoading) {
        this.tabsList[data.value].isLoading = true;
      }
      this.active = data.value;
    },
    openPickDate(type) {
      this.showTimePicker = true;
      this.chooseDateType = type;
      let data = this.form;
      if (this.chooseDateType === 0) {
        this.pickerTitle = "请选择筛选开始时间";
        this.dateTimePickDate = new Date(
          data.startDate.getFullYear(),
          data.startDate.getMonth(),
          data.startDate.getDate()
        );
      } else {
        this.pickerTitle = "请选择筛选结束时间";
        this.dateTimePickDate = new Date(
          data.endDate.getFullYear(),
          data.endDate.getMonth(),
          data.endDate.getDate()
        );
      }
    },
    onTimePickClick() {
      this.showTimePicker = false;
      let startDate;
      let endDate;
      if (this.chooseDateType === 0) {
        startDate = this.dateTimePickDate;
        endDate = this.form.endDate;
      } else {
        endDate = this.dateTimePickDate;
        startDate = this.form.startDate;
      }
      if (Date.parse(startDate) > Date.parse(endDate)) {
        this.$toast("开始时间不能大于结束时间");
        return;
      }
      this.form.startDate = startDate;
      this.form.endDate = endDate;
    },
  },
};
</script>

<style lang="less" scoped>
.page-my-order {
  height: 100%;
  display: flex;
  flex: 1;
  flex-direction: column;
  .consume {
    background-color: #f5f5f5;
    text-align: center;
    padding: 0.08rem 0 0.07rem 0;
    font-size: 0.24rem;
    line-height: 0.33rem;
    height: 0.33rem;
    color: #333;
    position: relative;
    .screen {
      color: #999999;
      font-size: 0.24rem;
      line-height: 0.33rem;
      position: absolute;
      right: 0;
      top: 0;
      padding: 0.09rem 0.2rem 0.06rem 0.2rem;
      img {
        width: 0.2rem;
        vertical-align: middle;
      }
    }
  }
  .user-type-picker {
    background: transparent;
    width: 94%;
    margin-left: 3%;
    .user-type-box {
      border-radius: 0.2rem;
      background-color: #fff;
      overflow: hidden;
      .user-type-item {
        line-height: 1.05rem;
        font-size: 0.36rem;
        color: #2a9efd;
        text-align: center;
        cursor: pointer;
        border-bottom: 0.01rem solid #c2c2c2;
      }
      .user-type-item:last-child {
        border-bottom: none;
      }
      .user-type-item:active {
        background-color: #f5f5f5;
      }
    }
    .user-type-box.cancel {
      margin-top: 0.09rem;
      margin-bottom: 0.2rem;
    }
  }
  .time-box {
    position: relative;
    .time-right-screen {
      position: absolute;
      right: 0;
      top: 0.4rem;
      padding-right: 0.2rem;
      color: #999999;
      font-size: 0.24rem;
      line-height: 0.33rem;
      display: flex;
      align-items: center;
      justify-content: center;
      vertical-align: middle;
      img {
        width: 0.2rem;
        height: 0.2rem;
      }
    }
  }
  .time-range-pick-container {
    display: flex;
    align-items: center;
    font-size: 0.34rem;
    color: #333333;
    background: #f8f4f5;
    box-sizing: border-box;
    margin: 0.24rem 1rem 0.06rem 1rem;
    line-height: 0.68rem;
    justify-content: center;

    .line {
      width: 0.2rem;
      height: 0.03rem;
      margin: 0 0.3rem;
      background: rgb(156, 153, 154);
    }
  }
}
</style>
